import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type NotificationDto } from '@/client/types.gen'
//import {NotificationService} from '@/services/NotificationsService'
import { NotificationsService } from '@/client/services.gen'

export const useNotificationStore = defineStore('notificationStore', () => {
  const notificationsState = ref<NotificationDto[] | null>([])
  const getNotifications = async () => {
    notificationsState.value = await NotificationsService.getApiNotificationsList();
    return notificationsState.value
  }

  const setNotificationsAsSeen = async () => {
    if (notificationsState.value?.length == 0) {
      return
    }
    await NotificationsService.postApiNotificationsSetAsSeen();

    notificationsState.value?.forEach(async (notification) => {
      notification.seenOn = new Date().toString();
    })
  }

  const deleteNotification = async (id: string) => {
    await NotificationsService.deleteApiNotificationsById({id});
  }
  const seenNotification = async (id: string) => {
    await NotificationsService.postApiNotifications({requestBody: {id}});
  }

   return {
    notificationsState,
    setNotificationsAsSeen,
    getNotifications,
    deleteNotification,
    seenNotification
  }
})
